import { TableColumnInputEnum } from '../../../../../Common/Forms/enums/table-column-input-type.enum';
import { TableColumnModel } from '../../../../../Common/Forms/models/table-column.model';

export const templateNameColumnConfig: TableColumnModel = {
    type: TableColumnInputEnum.text,
    heading: 'Briefings.templateManageDialog.column.templateName',
    field: 'name',
    tooltipField: 'name',
    sortable: true,
    sortType: 'text',
    maxWidth: 340,
    cellStyleClass: 'agpr-table-cell--primary',
    fieldMaxLength: 64,
    selectable: true,
    selectField: 'selected'
};
